import { render, staticRenderFns } from "./AharonovBohmEffectViz.vue?vue&type=template&id=5ed138ac&scoped=true"
import script from "./AharonovBohmEffectViz.vue?vue&type=script&lang=js"
export * from "./AharonovBohmEffectViz.vue?vue&type=script&lang=js"
import style0 from "./AharonovBohmEffectViz.vue?vue&type=style&index=0&id=5ed138ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed138ac",
  null
  
)

export default component.exports